import { render, staticRenderFns } from "./VideoClip02.vue?vue&type=template&id=36dd56bc"
import script from "./VideoClip02.vue?vue&type=script&lang=js"
export * from "./VideoClip02.vue?vue&type=script&lang=js"
import style0 from "./VideoClip02.vue?vue&type=style&index=0&id=36dd56bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports